import * as React from 'react';
import { View, Text, TouchableOpacity, ScrollView } from 'react-native';
import LabelItem from './labelItem';
import * as Handlers from './handle';
import * as Constants from './constant';
import theme, { Icon } from '@qnpm/q-theme';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
const { responsive: { screen, scale } } = theme;
export class Select extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // 组件宽度
            componentWidth: screen.width || 0
        };
    }
    render() {
        const { dataSource = [], type = 'base', accessibilityPreName = '' } = this.props;
        const { component, wrapper } = Handlers.getComponentStyles(this.props, this.state.componentWidth);
        return (<ScrollView style={component} ref={(ref) => {
            this.scrollRef = ref;
        }} showsHorizontalScrollIndicator={false} showsVerticalScrollIndicator={false} {...qAccessibilityLabel(`${accessibilityPreName}qdSelect#ScrollView`)} onLayout={(event) => {
            const { width } = event.nativeEvent.layout;
            this.scrollToSelectedIndex();
            if (type === 'label') {
                // 标签样式下，获取到组件宽度后，需要重新Render，用最新宽度计算每个标签的size
                this.setState({ componentWidth: width });
            }
        }}>
                <View style={wrapper}>
                    {dataSource.map((value, index) => this.renderSelectItem(value, index))}
                </View>
            </ScrollView>);
    }
    /**
     * 单个选择item
     * @param value 选项展示文本
     * @param index 选项index
     */
    renderSelectItem(value, index) {
        const { selectItem, type = 'base', selectedIndex = 0, labelType = 'side', disableIndexs = [], needScale = false, accessibilityPreName = '', renderLeftNode, renderItem } = this.props;
        const isBase = type === 'base';
        const { textWrapper, text, icon, line } = Handlers.getComponentStyles(this.props, this.state.componentWidth);
        const selected = index === selectedIndex;
        let textStyleKey = selected ? 'selected' : 'normal';
        const disable = disableIndexs.indexOf(index) > -1;
        textStyleKey = disable ? 'disable' : textStyleKey;
        const { marginLeft, fontSize, color } = icon;
        return (<TouchableOpacity key={`item${index}`} accessible={false} {...qAccessibilityLabel(`${accessibilityPreName}qdSelect#item#${index}#${disable}`)} activeOpacity={disable ? 1 : 0.7} onPress={() => {
            if (disable) {
                return;
            }
            selectItem && selectItem(value, index);
        }}>
                {renderItem ? (renderItem(index, selected)) : (<View style={[
            textWrapper,
            Handlers.getSelectBgColor(type, selected, labelType, disable)
        ]}>
                        {isBase ? (<>
                                {renderLeftNode && renderLeftNode(index)}
                                <Text style={text[textStyleKey]}>{value}</Text>
                            </>) : (<LabelItem style={text[textStyleKey]} value={value} needScale={needScale}/>)}
                        {isBase && selected && !disable ? (<Icon style={{ marginLeft }} size={fontSize} color={color} name="checked"/>) : null}
                    </View>)}
                {isBase ? <View style={line}/> : null}
            </TouchableOpacity>);
    }
    /**
     * 当初始化时，选中的Item超出组件首屏，则滚动至选择的item位置
     */
    scrollToSelectedIndex() {
        const { type = 'base', dataSource = [], itemHeight = Constants.kDefaultItemHeight[type], needScale = false } = this.props;
        // 每个Item的高度
        let itemNumberHeight = Handlers.changeStringToNumber(itemHeight);
        itemNumberHeight = scale(itemNumberHeight, needScale);
        // 所有Item加起来的高度
        const itemsHeight = (dataSource.length + 1) * itemNumberHeight;
        // 组件高度
        const comHeight = screen.height * 0.5;
        // 当前item所在的偏移位置
        const offset = this.getSelectedItemOffset();
        if (itemsHeight <= comHeight || offset <= comHeight) {
            return;
        }
        this.scrollRef &&
            this.scrollRef.scrollTo({ x: 0, y: offset, animated: true });
    }
    /**
     * 获取当前选中的Item的位置偏移量
     */
    getSelectedItemOffset() {
        const { type = 'base', selectedIndex = 0, numberOfLists = 2, itemHeight = Constants.kDefaultItemHeight[type], needScale = false } = this.props;
        // 每个Item的高度
        let itemNumberHeight = Handlers.changeStringToNumber(itemHeight);
        itemNumberHeight = scale(itemNumberHeight, needScale);
        let offset = 0;
        if (type === 'base') {
            offset = (selectedIndex + 1) * itemNumberHeight;
        }
        else {
            const rows = Math.ceil((selectedIndex + 1) / numberOfLists);
            offset =
                rows *
                    (itemNumberHeight +
                        scale(Constants.kLabelItemMargin, needScale));
        }
        return offset;
    }
}
